import Types from '../Types'
import Immutable from 'seamless-immutable'
import { createReducer } from 'reduxsauce'
import _get from 'lodash.get'
import _groupBy from 'lodash.groupby'
import _uniqBy from 'lodash.uniqby'

export const INITIAL_STATE = Immutable({
  error: null,
  findAttempting: false,
  products: [],
  pageCount: 0,
  findHomeAttempting: false,
  homeProducts: [],
  bestSellingAttempting: false,
  bestSellingProducts: [],
  promotionalAttempting: false,
  promotionalProducts: [],
  pricesAttempting: true,
  prices: {},
  findOneAttempting: false,
  product: {},
  findTagsAttempting: false,
  tagOptions: [],
  saveAttempting: false,

  findImagesAttempting: false,
  productImages: []
})

const mutateProducts = (result) =>
  (product) =>
    result.productCode === product.productCode
      ? { ...product, userId: result.userId }
      : product

// const mergeUnits = (input) => {
//   const _productMap = _groupBy(input, 'productCode')
//   return Object.keys(_productMap).map(_productCode => {
//     const _products = _productMap[_productCode]
//     return {
//       companyCode: _get(_products, '0.companyCode'),
//       companyName: _get(_products, '0.companyName'),
//       createdAt: _get(_products, '0.createdAt'),
//       description: _get(_products, '0.description'),
//       genericName: _get(_products, '0.genericName'),
//       imagePath: _get(_products, '0.imagePath'),
//       productCode: _get(_products, '0.productCode'),
//       productName: _get(_products, '0.productName'),
//       promotional: _get(_products, '0.promotional'),
//       recommended: _get(_products, '0.recommended'),
//       remark: _get(_products, '0.remark'),
//       status: _get(_products, '0.active'),
//       userId: _get(_products, '0.userId'),
//       units: _products.map(({ unit, unitId, barcode, retail, wholesale1, wholesale2, wholesale3, wholesale4 }) => ({
//         unit,
//         unitId,
//         barcode,
//         retail,
//         wholesale1,
//         wholesale2,
//         wholesale3,
//         wholesale4
//       }))
//     }
//   })
// }

const ACTION_HANDLERS = {
  [Types.ADD_TO_WISHLIST_SUCCESS]: (state, action) =>
    state.merge({
      products: (state.products || []).map(mutateProducts(action.result)),
      homeProducts: (state.homeProducts || []).map(mutateProducts(action.result)),
      bestSellingProducts: (state.bestSellingProducts || []).map(mutateProducts(action.result)),
      promotionalProducts: (state.promotionalProducts || []).map(mutateProducts(action.result)),
      recommendations: (state.recommendations || []).map(mutateProducts(action.result)),
      product: mutateProducts(action.result)(state.product)
    }),
  [Types.REMOVE_FROM_WISHLIST_SUCCESS]: (state, action) =>
    state.merge({
      products: (state.products || []).map(mutateProducts(action.result)),
      homeProducts: (state.homeProducts || []).map(mutateProducts(action.result)),
      bestSellingProducts: (state.bestSellingProducts || []).map(mutateProducts(action.result)),
      promotionalProducts: (state.promotionalProducts || []).map(mutateProducts(action.result)),
      recommendations: (state.recommendations || []).map(mutateProducts(action.result)),
      product: mutateProducts(action.result)(state.product)
    }),

  [Types.FIND_PRODUCTS_ATTEMPT]: (state, action) =>
    state.merge({ findAttempting: true }),
  [Types.FIND_PRODUCTS_SUCCESS]: (state, action) =>
    state.merge({
      findAttempting: false,
      products: action.result.products,
      pageCount: action.result.pageCount,
      error: null
    }),
  [Types.FIND_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({ findAttempting: false, error: action.error }),

  [Types.FIND_ALL_PRODUCTS_ATTEMPT]: (state, action) =>
    state.merge({ findAttempting: true }),
  [Types.FIND_ALL_PRODUCTS_SUCCESS]: (state, action) =>
    state.merge({
      findAttempting: false,
      products: action.result.products,
      pageCount: action.result.pageCount,
      error: null
    }),
  [Types.FIND_ALL_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({ findAttempting: false, error: action.error }),

  [Types.FIND_HOME_PRODUCTS_ATTEMPT]: (state, action) =>
    state.merge({ findHomeAttempting: true }),
  [Types.FIND_HOME_PRODUCTS_SUCCESS]: (state, action) =>
    state.merge({
      findHomeAttempting: false,
      homeProducts: action.result,
      pageCount: 1,
      error: null
    }),
  [Types.FIND_HOME_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({ findHomeAttempting: false, error: action.error }),

  [Types.FIND_BEST_SELLING_PRODUCTS_ATTEMPT]: (state, action) =>
    state.merge({ bestSellingAttempting: true }),
  [Types.FIND_BEST_SELLING_PRODUCTS_SUCCESS]: (state, action) =>
    state.merge({
      bestSellingAttempting: false,
      bestSellingProducts: action.result,
      error: null
    }),
  [Types.FIND_BEST_SELLING_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({ bestSellingAttempting: false, error: action.error }),

  [Types.FIND_PROMOTIONAL_PRODUCTS_ATTEMPT]: (state, action) =>
    state.merge({ promotionalAttempting: true }),
  [Types.FIND_PROMOTIONAL_PRODUCTS_SUCCESS]: (state, action) => {
    return state.merge({
      promotionalAttempting: false,
      promotionalProducts: action.result,
      error: null
    })
  },
  [Types.FIND_PROMOTIONAL_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({ promotionalAttempting: false, error: action.error }),

  [Types.FIND_GIVEAWAY_PRODUCTS_ATTEMPT]: (state, action) =>
    state.merge({ giveawayAttempting: true }),
  [Types.FIND_GIVEAWAY_PRODUCTS_SUCCESS]: (state, action) =>
    state.merge({
      giveawayAttempting: false,
      giveawayProducts: action.result,
      error: null
    }),
  [Types.FIND_GIVEAWAY_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({ giveawayAttempting: false, error: action.error }),

  [Types.FIND_BIS_PRODUCTS_ATTEMPT]: (state, action) => 
    state.merge({ bisAttempting: true }),
  [Types.FIND_BIS_PRODUCTS_SUCCESS]: (state, action) =>
    state.merge({
      bisAttempting: false,
      bisProducts: action.result,
      error: null
    }),
  [Types.FIND_BIS_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({ bisAttempting: false, error: action.error }),

  [Types.FIND_PRICES_ATTEMPT]: (state, action) =>
    state.merge({ pricesAttempting: true }),
  [Types.FIND_PRICES_SUCCESS]: (state, action) =>
    state.merge({
      pricesAttempting: false,
      pageCount: action.result.pageCount,
      prices: _groupBy(action.result.products, price => price.companyName),
      error: null
    }),
  [Types.FIND_PRICES_FAILURE]: (state, action) =>
    state.merge({ pricesAttempting: false, error: action.error }),

  [Types.FIND_ONE_PRODUCT_ATTEMPT]: (state, action) =>
    state.merge({ findOneAttempting: true, product: {} }),
  [Types.FIND_ONE_PRODUCT_SUCCESS]: (state, action) =>
    state.merge({ findOneAttempting: false, product: action.result, error: null }),
  [Types.FIND_ONE_PRODUCT_FAILURE]: (state, action) =>
    state.merge({ findOneAttempting: false, error: action.error }),

  [Types.IMPORT_PRODUCTS_ATTEMPT]: (state, action) =>
    state.merge({ importAttempting: true }),
  [Types.IMPORT_PRODUCTS_SUCCESS]: (state, action) => {
    window.location.reload()
    return state.merge({
      importAttempting: false,
      error: null
    })
  },
  [Types.IMPORT_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({
      importAttempting: false,
      error: action.error
    }),

  [Types.IMPORT_TAGS_ATTEMPT]: (state, action) =>
    state.merge({ importTagsAttempting: true }),
  [Types.IMPORT_TAGS_SUCCESS]: (state, action) => {
    window.location.reload()
    return state.merge({ importTagsAttempting: false, error: null })
  },
  [Types.IMPORT_TAGS_FAILURE]: (state, action) =>
    state.merge({ importTagsAttempting: false, error: action.error }),

  [Types.IMPORT_CONFIGS_ATTEMPT]: (state, action) =>
    state.merge({ importConfigsAttempting: true }),
  [Types.IMPORT_CONFIGS_SUCCESS]: (state, action) => {
    window.location.reload()
    return state.merge({ importConfigsAttempting: false, error: null })
  },
  [Types.IMPORT_CONFIGS_FAILURE]: (state, action) =>
    state.merge({ importConfigsAttempting: false, error: action.error }),

  [Types.IMPORT_STOCKS_ATTEMPT]: (state, action) =>
    state.merge({ importStocksAttempting: true }),
  [Types.IMPORT_STOCKS_SUCCESS]: (state, action) => {
    window.location.reload()
    return state.merge({ importStocksAttempting: false, error: null })
  },
  [Types.IMPORT_STOCKS_FAILURE]: (state, action) =>
    state.merge({ importStocksAttempting: false, error: action.error }),

  [Types.IMPORT_BIS_ATTEMPT]: (state, action) =>
    state.merge({ importBisAttempting: true }),
  [Types.IMPORT_BIS_SUCCESS]: (state, action) => {
    window.location.reload()
    return state.merge({ importBisAttempting: false, error: null })
  },
  [Types.IMPORT_BIS_FAILURE]: (state, action) =>
    state.merge({ importBisAttempting: false, error: action.error }),

  [Types.IMPORT_FD_ATTEMPT]: (state, action) =>
    state.merge({ importFdAttempting: true }),
  [Types.IMPORT_FD_SUCCESS]: (state, action) => {
    window.location.reload()
    return state.merge({ importFdAttempting: false, error: null })
  },
  [Types.IMPORT_FD_FAILURE]: (state, action) =>
    state.merge({ importFdAttempting: false, error: action.error }),

  [Types.SAVE_PRODUCT_ATTEMPT]: (state, action) =>
    state.merge({ saveAttempting: true }),
  [Types.SAVE_PRODUCT_SUCCESS]: (state, action) =>
    state.merge({ saveAttempting: false, product: action.result, error: null }),
  [Types.SAVE_PRODUCT_FAILURE]: (state, action) =>
    state.merge({ saveAttempting: false, error: action.error }),

  [Types.FIND_TAGS_ATTEMPT]: (state, action) =>
    state.merge({ findTagsAttempting: true }),
  [Types.FIND_TAGS_SUCCESS]: (state, action) =>
    state.merge({ findTagsAttempting: false, tagOptions: action.result || [], error: null }),
  [Types.FIND_TAGS_FAILURE]: (state, action) =>
    state.merge({ findTagsAttempting: false, error: action.error }),

  [Types.FIND_PRODUCT_RECOMMENDATIONS_ATTEMPT]: (state, action) =>
    state.merge({ findRecommendationsAttempting: true }),
  [Types.FIND_PRODUCT_RECOMMENDATIONS_SUCCESS]: (state, action) =>
    state.merge({
      findRecommendationsAttempting: false,
      recommendations: _uniqBy(
        (_get(action, 'result.products1') || []).concat(_get(action, 'result.products2') || [])
        , ({ productCode }) => productCode),
      error: null
    }),
  [Types.FIND_PRODUCT_RECOMMENDATIONS_FAILURE]: (state, action) =>
    state.merge({ findRecommendationsAttempting: false, error: action.error }),

  [Types.AGGREGATE_PRODUCTS_ATTEMPT]: (state, action) =>
    state.merge({ aggregateProductsAttempting: true }),
  [Types.AGGREGATE_PRODUCTS_SUCCESS]: (state, action) =>
    state.merge({ aggregateProductsAttempting: false, aggregateResult: action.result, error: null }),
  [Types.AGGREGATE_PRODUCTS_FAILURE]: (state, action) =>
    state.merge({ aggregateProductsAttempting: false, error: action.error }),

  [Types.FIND_PRODUCT_IMAGES_ATTEMPT]: (state, action) =>
    state.merge({ findImagesAttempting: true }),
  [Types.FIND_PRODUCT_IMAGES_SUCCESS]: (state, action) =>
    state.merge({ findImagesAttempting: false, productImages: action.result || [], error: null }),
  [Types.FIND_PRODUCT_IMAGES_FAILURE]: (state, action) =>
    state.merge({ findImagesAttempting: false, error: action.error }),

  [Types.ADD_PRODUCT_IMAGE_ATTEMPT]: (state, action) =>
    state.merge({ addProductImageAttempting: true }),
  [Types.ADD_PRODUCT_IMAGE_SUCCESS]: (state, action) =>
    state.merge({ addProductImageAttempting: false, productImages: state.productImages.concat([action.result]), error: null }),
  [Types.ADD_PRODUCT_IMAGE_FAILURE]: (state, action) =>
    state.merge({ addProductImageAttempting: false, error: action.error }),

  [Types.REMOVE_PRODUCT_IMAGE_ATTEMPT]: (state, action) =>
    state.merge({ removeProductImageAttempting: true }),
  [Types.REMOVE_PRODUCT_IMAGE_SUCCESS]: (state, action) =>
    state.merge({
      removeProductImageAttempting: false,
      productImages: state.productImages.filter(img => `${img.id}` !== _get(action, 'result.productImageId'))
    }),
  [Types.REMOVE_PRODUCT_IMAGE_FAILURE]: (state, action) =>
    state.merge({
      removeProductImageAttempting: false,
      error: action.error
    })
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)



/** WEBPACK FOOTER **
 ** ./src/redux/product/productReducer.js
 **/